import { ReactNode, useMemo } from "react";
import { NAV_ITEM_BUTTON_STYLES } from "./constants";
import { Button, cn } from "@tellescope/ui";
import { ChevronDown } from "lucide-react";
import { useLocation } from "react-router-dom";
import { type FeaturePageName, getFeatureDisplayName, useOrgFeatures } from "../../../permissions";

export interface NavbarGroupHeaderProps {
  isOpen: boolean;
  onClick: () => void;
  label: string;
  icon?: ReactNode;
  path: string;
  featureName?: FeaturePageName;
}

export const NavbarGroupHeader = ({ isOpen, onClick, label, icon, path, featureName }: NavbarGroupHeaderProps) => {
  const location = useLocation();
  const { plan } = useOrgFeatures();
  const currentPathname = location.pathname;
  const isActive = useMemo(() => {
    if (isOpen) {
      return false;
    }
    return currentPathname.startsWith(path);
  }, [currentPathname, isOpen, path]);

  const trackingId = `nav-group-${path.replace(/\//g, "-").replace(/^-/, "")}`;

  const labelOverride = featureName ? getFeatureDisplayName({ plan, featureName }) : undefined;

  return (
    <Button
      className={cn(NAV_ITEM_BUTTON_STYLES, "justify-between flex-shrink-0")}
      onClick={onClick}
      variant={isActive ? "secondary" : "ghost"}
      data-trackingid={trackingId}
      data-testid={trackingId}
    >
      <div className="flex gap-4 items-center">
        {icon}
        {labelOverride || label}
      </div>
      <ChevronDown className={cn("text-sidebar-foreground transition-all", isOpen ? "rotate-180" : "")} />
    </Button>
  );
};
